import { authHttp } from '../http'
import * as routes from '../../routes/patio.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function getMovimentacoes({ tp_id, pInicial, pFinal }) {
  try {
    const { data } = await authHttp().get(routes.urlGetBalancaMovimentacoes, {
      params: { tp_id, pInicial, pFinal },
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveMovimentacao(payload) {
  try {
    const { id: userId } = getUsuarioInfo()
    const { data } = await authHttp().post(routes.urlPostBalancaMovimentacao(userId), payload)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function finalizarMovimentacao(id) {
  try {
    const { data } = await authHttp().patch(routes.urlPatchFinalizarBalancaMovimentacao(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
